import {
  Article as ArticleIcon,
  AutoStoriesRounded,
  EmojiEvents as GamificationIcon,
  LiveTv as LiveTvIcon,
  PictureAsPdf as PdfIcon,
  SpaceDashboard as HomeProgramIcon,
  SportsSoccer as SportsIcon,
  Web as CmsIcon,
} from '@mui/icons-material';
import type { NavItemType } from '../types/menu';

const icons = {
  content: AutoStoriesRounded,
  article: ArticleIcon,
  gamification: GamificationIcon,
  cms: CmsIcon,
  streaming: LiveTvIcon,
  sportsPackages: SportsIcon,
  leagues: GamificationIcon,
  homeProgram: HomeProgramIcon,
  pdfChannels: PdfIcon,
};

const content: NavItemType = {
  id: 'group-content',
  title: 'Content',
  type: 'group',
  icon: icons.content,
  children: [
    {
      id: 'providersandchannels',
      title: 'TV Services',
      type: 'item',
      url: '/providersandchannels',
      icon: icons.article,
      permissionModule: 'providers',
    },
    {
      id: 'pdf-channel-selection',
      title: 'PDF Channels',
      type: 'item',
      url: '/pdf-channel-selection',
      icon: icons.pdfChannels,
      permissionModule: 'providers',
    },
    {
      id: 'streaming-services',
      title: 'Streaming Services',
      type: 'item',
      url: '/streaming-services',
      icon: icons.streaming,
      permissionModule: 'streaming_services',
    },
    {
      id: 'sports-packages',
      title: 'Sports Packages',
      type: 'item',
      url: '/sports-packages',
      icon: icons.sportsPackages,
      permissionModule: 'sports_packages',
    },
    {
      id: 'leagues',
      title: 'Leagues',
      type: 'item',
      url: '/leagues',
      icon: icons.leagues,
      permissionModule: 'leagues',
    },
    {
      id: 'cms',
      title: 'CMS Pages',
      type: 'item',
      url: '/cms',
      icon: icons.cms,
      permissionModule: 'cms',
    },
    {
      id: 'home-programs',
      title: 'Home programs',
      type: 'item',
      url: '/home-programs',
      icon: icons.homeProgram,
      permissionModule: 'home_programs',
    },
  ],
};

export default content;
